

// const macFileName = "EffectsStudio_1.3.0_Mac.zip";
// const windowsFileName = "EffectsStudio_1.3.0_Win.zip";
const macFileName = "EffectsStudio_1.6.0_Mac.zip";
const windowsFileName = "EffectsStudio_1.6.0_Win.msi";

const windowsUrl =
    `https://sense-ar.tos-cn-shanghai.volces.com/effects-studio/${windowsFileName}`;
const macUrl =
    `https://sense-ar.tos-cn-shanghai.volces.com/effects-studio/${macFileName}`;

const downloadToolNow = () => {
  const isMac = /macintosh|mac os x/i.test(navigator.userAgent);

  let zipUrl = "";
  let fileName = "";

  if (isMac) {
    // Mac
    zipUrl = macUrl;
    fileName = macFileName;
  } else {
    // Windows
    zipUrl = windowsUrl;
    fileName = windowsFileName;
  }

  const a = document.createElement("a");
  a.href = zipUrl;
  a.setAttribute("download", fileName);
  a.click();
};

export { windowsUrl, macUrl, windowsFileName, macFileName, downloadToolNow };
